import uuid from "react-uuid";
/**
 *  * Service permettant de réunir les urls des différents appels ainsi que
 *  * l'url du server pour faciliter le changement d'url
 *  ? On aura baseUrl, serverName ...
 * **/
const serverConfig = {
  serverBaseUrl: "http://127.0.0.1:8181/app/memv2",
  serverRootUrl: "https://127.0.0.1"
}


export const setServerBaseUrl = (url) => {
  if (url === '127.0.0.1')
    serverConfig.serverBaseUrl = "http://" + url + ":8181/app/memv2";
  else
    serverConfig.serverBaseUrl = "https://" + url + "/avobbesnetwork/app/memv2";
  console.log("Server base url : ", serverConfig);
  serverConfig.serverRootUrl = "https://" + url;
  //baseUrl: `https://demo.avob.com/avobbesnetwork/app/memv2`,
  //baseUrl: `http://127.0.0.1:8181/app/memv2`
  //baseUrl: `http://127.0.0.1:8080/avobbesnetwork/app/memv2`,
  //baseUrl: `https://prod2.avob.com/avobbesnetwork/app/memv2`,
};
export const getServerBaseUrl = () => {
  return serverConfig.serverBaseUrl;
};
export const getServerRootUrl = () => {
  return serverConfig.serverRootUrl;
};

export const getAuth = () => {
  return `${getServerBaseUrl()}/authorization?app=MEMV2`;
};
export const postSimpleSearch = (idGroup) => {
  return `${getServerBaseUrl()}/simplesearch?app=MEMV2&idgroup=${idGroup}`;
};
export const postUser = () => {
  return `${getServerBaseUrl()}/user?app=MEMV2`;
};
export const postAdvancedSearch = (idGroup) => {
  return `${getServerBaseUrl()}/advancedsearch?app=MEMV2&idgroup=${idGroup}`;
};
export const postAlertAcquittement = (alertid) => {
  return `${getServerBaseUrl()}/alertacquitment?app=MEMV2&alertid=${alertid}`;
};
export const getFileDownload = (fileid) => {
  return `${getServerBaseUrl()}/filedownload?app=MEMV2&fileid=${fileid}`;
};
export const postPermission = () => {
  return `${getServerBaseUrl()}/permission?app=MEMV2`;
};
export const postDashboard = () => {
  return `${getServerBaseUrl()}/dashboard?app=MEMV2`;
};
export const getUserProfileData = () => {
  return `${getServerBaseUrl()}/userprofile`;
};
export const updateUserProfileData = () => {
  return `${getServerBaseUrl()}/userprofile`;
};
export const getChart = (
  idGroup,
  chartId,
  chartDateBegin,
  chartDateEnd,
  multigroupmode,
  chartsource,
  type,
  granularity,
  name,
  definition,
  pointid,
  apppointid,
  campaignid,
  requestid,
) => {
  if (!requestid)
    requestid = uuid();
  if (!chartsource || chartsource === 'existing')
    return `${getServerBaseUrl()}/chart?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&requestid=${requestid}`;
  else if (chartsource === 'definition')
    return `${getServerBaseUrl()}/chart?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&type=${type}&granularity=${granularity}&name=${name}&definition=${definition}&campaignid=${campaignid}&requestid=${requestid}`;
  else if (chartsource === 'point') {
    if (pointid)
      return `${getServerBaseUrl()}/chart?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&type=${type}&granularity=${granularity}&name=${name}&pointid=${pointid}&campaignid=${campaignid}&requestid=${requestid}`;
    else if (apppointid)
      return `${getServerBaseUrl()}/chart?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&type=${type}&granularity=${granularity}&name=${name}&apppointid=${apppointid}&campaignid=${campaignid}&requestid=${requestid}`;
  }
};
export const getChartStop = (requestid) => {
  return `${getServerBaseUrl()}/chartstop?requestid=${requestid}`;
};
export const getMaps = (type, idGroup, option) => {
  return `${getServerBaseUrl()}/maps?type=${type}&idgroup=[${idGroup}]&option=${option}`;
};
export const getMapsLocationInfo = (idGroup, idseries) => {
  return `${getServerBaseUrl()}/mapslocationinfo?idgroup=${idGroup}&series=${idseries}`;
};
export const getHome = (idGroup, idseries, topserie) => {
  return `${getServerBaseUrl()}/home?idgroup=${idGroup}&series=${idseries}&topserie=${topserie}`;
};
export const getAlert = (idGroup) => {
  return `${getServerBaseUrl()}/alert?app=MEMV2&idgroup=${idGroup}`;
};
export const getAlertDetail = (idAlert) => {
  return `${getServerBaseUrl()}/alertdetail?app=MEMV2&alertid=${idAlert}`;
};
export const getAlertAcquitment = (idAlert, status) => {
  return `${getServerBaseUrl()}/alertacquitment?app=MEMV2&alertid=${idAlert}&status=${status}`;
};
export const getAlerts = (idGroup, pageSize, page, sorted, filterValue, method, hideclosed) => {
  if (method && method === 'count') {
    return `${getServerBaseUrl()}/alert?app=MEMV2&method=${method}&idgroup=${idGroup}`;
  }
  else {

    if (sorted) {
      if (filterValue)
        return `${getServerBaseUrl()
          }/alert?app=MEMV2&per=${pageSize}&page=${page}&filtered=[{"id":"text","value":"${filterValue}"}]&sorted=${JSON.stringify(
            sorted
          )}&idgroup=${idGroup}&hideclosed=${hideclosed}`;
      else
        return `${getServerBaseUrl()
          }/alert?app=MEMV2&per=${pageSize}&page=${page}&sorted=${JSON.stringify(
            sorted
          )}&idgroup=${idGroup}&hideclosed=${hideclosed}`;
    } else if (filterValue) {
      return `${getServerBaseUrl()}/alert?app=MEMV2&per=${pageSize}&page=${page}&filtered=[{"id":"text","value":"${filterValue}"}]&idgroup=${idGroup}&hideclosed=${hideclosed}`;
    } else {
      return `${getServerBaseUrl()}/alert?app=MEMV2&per=${pageSize}&page=${page}&idgroup=${idGroup}&hideclosed=${hideclosed}`;
    }
  }
};
export const getUsers = (idGroup, method) => {
  if (!method)
    method = 'all';
  return `${getServerBaseUrl()}/users?app=MEMV2&idgroup=${idGroup}&method=${method}`;
};
export const postUsers = (method) => {
  return `${getServerBaseUrl()}/users?app=MEMV2&method=${method}`;
};
export const deleteUser = (idSelected) => {
  return `${getServerBaseUrl()}/user/${idSelected}?app=MEMV2`;
};
export const deletePermission = (idSelected) => {
  return `${getServerBaseUrl()}/permission/${idSelected}?app=MEMV2`;
};
export const getPermission = (idSelected) => {
  return `${getServerBaseUrl()}/permission?app=MEMV2&id=${idSelected}`;
};
export const getDashboard = (idSelected) => {
  return `${getServerBaseUrl()}/dashboard?app=MEMV2&id=${idSelected}`;
};
export const deleteDashboard = (idSelected) => {
  return `${getServerBaseUrl()}/dashboard/${idSelected}?app=MEMV2`;
};
export const getChartList = (idGroup) => {
  return `${getServerBaseUrl()}/charts?app=MEMV2&idgroup=${idGroup}`;
};
export const getSite = (idGroup, key, showall) => {
  if (key)
    return `${getServerBaseUrl()}/site?app=MEMV2&idgroup=${idGroup}&key=${key}&showall=${showall}`;
  else return `${getServerBaseUrl()}/site?app=MEMV2&idgroup=${idGroup}`;
};
export const getProfilePicture = (filecode) => {
  return `${getServerBaseUrl()}/filedownload/profilepic/${filecode}`;
};
export const getFiles = (idGroup, extension) => {
  if (!extension)
    extension = 'all';
  return `${getServerBaseUrl()}/files?app=MEMV2&idgroup=${idGroup}&extension=${extension}`;
};
export const deleteFiles = (fileid) => {
  return `${getServerBaseUrl()}/files?app=MEMV2&fileid=${fileid}`;
};
export const postComment = (fileid) => {
  return `${getServerBaseUrl()}/files?app=MEMV2&fileid=${fileid}`;
};

export const postFileUpload = (idGroup, type) => {
  return `${getServerBaseUrl()}/fileupload?app=MEMV2&idgroup=${idGroup}&type=${type}`;
};
export const downloadFile = (filecode, type) => {
  if (!type)
    return `${getServerBaseUrl()}/filedownload?app=MEM&fileid=${filecode}`;
  else
    return `${getServerBaseUrl()}/filedownload?app=MEM&fileid=${filecode}&type=${type}`;
};
export const getFileName = (filecode) => {
  return `${getServerBaseUrl()}/filename?app=MEM&fileid=${filecode}`;
};
export const getActionPlansList = (idGroup) => {
  return `${getServerBaseUrl()}/actionplans?app=MEMV2&idgroup=${idGroup}`;
};
export const getActionPlan = (id) => {
  return `${getServerBaseUrl()}/actionplan?app=MEMV2&id=${id}`;
};
export const putActionPlan = (id) => {
  return `${getServerBaseUrl()}/actionplan?app=MEMV2&id=${id}`;
};
export const postActionPlan = () => {
  return `${getServerBaseUrl()}/actionplan?app=MEMV2`;
};
export const deleteActionPlan = (id) => {
  return `${getServerBaseUrl()}/actionplan/${id}`;
};
export const getActionPlanScenario = (id) => {
  return `${getServerBaseUrl()}/actionplanscenario?app=MEMV2&id=${id}`;
};
export const postActionPlanScenario = (id) => {
  return `${getServerBaseUrl()}/actionplanscenario?app=MEMV2`;
};
export const putActionPlanScenario = (id) => {
  return `${getServerBaseUrl()}/actionplanscenario?app=MEMV2&id=${id}`;
};
export const deleteActionPlanScenario = (id) => {
  return `${getServerBaseUrl()}/actionplanscenario/${id}`;
};
export const getAction = (id) => {
  return `${getServerBaseUrl()}/action?app=MEMV2&id=${id}`;
};
export const postAction = (id) => {
  return `${getServerBaseUrl()}/action?app=MEMV2`;
};
export const postActionImpact = (id) => {
  return `${getServerBaseUrl()}/actionimpact?app=MEMV2`;
};
export const putAction = (id) => {
  return `${getServerBaseUrl()}/action?app=MEMV2&id=${id}`;
};
export const deleteAction = (id) => {
  return `${getServerBaseUrl()}/action/${id}`;
};
export const getActionTURPE = (idGroup) => {
  return `${getServerBaseUrl()}/actionturpe?app=MEMV2&idgroup=${idGroup}`;
};
export const getActionContract = (idGroup, energy) => {
  return `${getServerBaseUrl()}/actioncontract?app=MEMV2&idgroup=${idGroup}&energy=${energy}`;
};
export const getAPIAuthorizationList = (idGroup) => {
  return `${getServerBaseUrl()}/apiauthorizations?app=MEMV2&idgroup=${idGroup}`;
};
export const getAPIAuthorization = (id) => {
  return `${getServerBaseUrl()}/apiauthorization?app=MEMV2&id=${id}`;
};
export const deleteAPIAuthorization = (idSelected) => {
  return `${getServerBaseUrl()}/apiauthorization/${idSelected}?app=MEMV2`;
};
export const postAPIAuthorization = (idGroup) => {
  return `${getServerBaseUrl()}/apiauthorization?app=MEMV2&idgroup=${idGroup}`;
};
export const getExportsList = (idGroup) => {
  return `${getServerBaseUrl()}/exports?app=MEMV2&idgroup=${idGroup}`;
};
export const getExport = (id) => {
  return `${getServerBaseUrl()}/export?app=MEMV2&id=${id}`;
};
export const postExport = () => {
  return `${getServerBaseUrl()}/export?app=MEMV2`;
};
export const getExportParseFile = (fileid) => {
  return `${getServerBaseUrl()}/exportparsefile?app=MEMV2&fileid=${fileid}`;
};
export const generateExport = (id) => {
  return `${getServerBaseUrl()}/exportgenerate?app=MEMV2&id=${id}`;
};
export const deleteExport = (id) => {
  return `${getServerBaseUrl()}/export/${id}`;
};
export const getAlertRules = (idGroup) => {
  return `${getServerBaseUrl()}/alertrules?app=MEMV2&idgroup=${idGroup}`;
};
export const getAlertRule = (id) => {
  return `${getServerBaseUrl()}/alertrule?app=MEMV2&id=${id}`;
};
export const postAlertRule = () => {
  return `${getServerBaseUrl()}/alertrule?app=MEMV2`;
};
export const deleteAlertRule = (id) => {
  return `${getServerBaseUrl()}/alertrule/${id}`;
};
export const getArchitecture = (idGroup) => {
  if (idGroup)
    return `${getServerBaseUrl()}/architecture?app=MEMV2&idgroup=${idGroup}`;
  else
    return `${getServerBaseUrl()}/architecture?app=MEMV2`;
};
export const getIndicators = (idGroup, page, granularity) => {
  return `${getServerBaseUrl()}/indicators?app=MEMV2&idgroup=${idGroup}&page=${page}&granularity=${granularity}`;
};
export const getAccountMeters = (accountid, energy, filteredgroup, method) => {
  if (!method)
    method = 'standard';
  if (filteredgroup)
    return `${getServerBaseUrl()}/accountmeters?app=MEMV2&energy=${energy}&filteredgroup=${filteredgroup}&method=${method}`;
  else
    return `${getServerBaseUrl()}/accountmeters?app=MEMV2&accountid=${accountid}&energy=${energy}&method=${method}`;
};
export const updateAccountMeter = (uuid, idGroup, energy) => {
  return `${getServerBaseUrl()}/accountmeter?app=MEMV2&idgroup=${idGroup}&energy=${energy}&uuid=${uuid}`;
};
export const postAccountMeters = (method, idGroup, energy, datebegin, dateend, type, sendzero, format) => {
  if (method === "resenddata")
    return `${getServerBaseUrl()}/accountmeters?app=MEMV2&method=${method}&idgroup=${idGroup}&energy=${energy}&datebegin=${datebegin}&dateend=${dateend}&type=${type}&sendzero=${sendzero}&format=${format}`;
};
export const updateAccountMeters = (method, idGroup, energy) => {
  return `${getServerBaseUrl()}/accountmeters?app=MEMV2&method=${method}&idgroup=${idGroup}&energy=${energy}`;
};
export const getAccountContracts = (idGroup, energy) => {
  return `${getServerBaseUrl()}/accountcontracts?app=MEMV2&idgroup=${idGroup}&energy=${energy}`;
};
export const updateAccountContract = (uuid, idGroup, energy) => {
  return `${getServerBaseUrl()}/accountcontract?app=MEMV2&idgroup=${idGroup}&energy=${energy}&uuid=${uuid}`;
};
export const getAccountDsos = (idGroup, energy) => {
  return `${getServerBaseUrl()}/accountdsos?app=MEMV2&idgroup=${idGroup}&energy=${energy}`;
};
export const updateAccountDso = (uuid, idGroup, energy) => {
  return `${getServerBaseUrl()}/accountdso?app=MEMV2&idgroup=${idGroup}&energy=${energy}&uuid=${uuid}`;
};
export const getDataFiles = (idGroup) => {
  return `${getServerBaseUrl()}/datafiles?app=MEMV2&idgroup=${idGroup}`;
};
export const postDataFiles = (idGroup, type, datatype) => {
  return `${getServerBaseUrl()}/datafileupload?app=MEMV2&idgroup=${idGroup}&type=${type}&datatype=${datatype}`;
};
export const getDataFileLog = (datafileid) => {
  return `${getServerBaseUrl()}/datafilelog?app=MEMV2&datafileid=${datafileid}`;
};
export const reloadDataFile = (datafileid) => {
  return `${getServerBaseUrl()}/datafiles?app=MEMV2&datafileid=${datafileid}&reload=1`;
};
export const getMarkets = (idGroup) => {
  return `${getServerBaseUrl()}/markets?app=MEMV2&idgroup=${idGroup}`;
};
export const getMarket = (id) => {
  return `${getServerBaseUrl()}/market?app=MEMV2&id=${id}`;
};
export const putMarket = (id) => {
  return `${getServerBaseUrl()}/market?app=MEMV2&id=${id}`;
};
export const postMarket = () => {
  return `${getServerBaseUrl()}/market?app=MEMV2`;
};
export const deleteMarket = (id) => {
  return `${getServerBaseUrl()}/market/${id}`;
};
export const getMarketMemberships = (idGroup, idmarket) => {
  return `${getServerBaseUrl()}/marketmemberships?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}`;
};
export const getMarketMembership = (id) => {
  return `${getServerBaseUrl()}/marketmembership?app=MEMV2&id=${id}`;
};
export const putMarketMembership = (id) => {
  return `${getServerBaseUrl()}/marketmembership?app=MEMV2&id=${id}`;
};
export const postMarketMembership = (idmarket) => {
  return `${getServerBaseUrl()}/marketmembership?app=MEMV2&idmarket=${idmarket}`;
};
export const deleteMarketMembership = (id) => {
  return `${getServerBaseUrl()}/marketmembership/${id}`;
};
export const getMarketMeters = (idGroup, idmarket, marketmembershipid) => {
  if (!marketmembershipid)
    return `${getServerBaseUrl()}/marketmeters?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}`;
  else
    return `${getServerBaseUrl()}/marketmeters?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}&marketmembershipid=${marketmembershipid}`;
};
export const postMarketMeters = (marketmembershipid) => {
  return `${getServerBaseUrl()}/marketmeters?app=MEMV2&marketmembershipid=${marketmembershipid}`;
};
export const putMarketMeters = (method) => {
  return `${getServerBaseUrl()}/marketmeters?app=MEMV2&method=${method}`;
};
export const getMarketFiles = (idGroup, idmarket, filetype) => {
  return `${getServerBaseUrl()}/marketfiles?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}&filetype=${filetype}`;
};
export const postMarketFile = (idmarket, filetype) => {
  return `${getServerBaseUrl()}/marketfile?app=MEMV2&idmarket=${idmarket}&filetype=${filetype}`;
};
export const putMarketFile = (id) => {
  return `${getServerBaseUrl()}/marketfile?app=MEMV2&id=${id}`;
};
export const deleteMarketFile = (id) => {
  return `${getServerBaseUrl()}/marketfile/${id}`;
};
export const getMarketMembershipFiles = (idGroup, idmarket, filetype) => {
  return `${getServerBaseUrl()}/marketmembershipfiles?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}&filetype=${filetype}`;
};
export const postMarketMembershipFile = (marketmembershipid, filetype) => {
  return `${getServerBaseUrl()}/marketmembershipfile?app=MEMV2&marketmembershipid=${marketmembershipid}&filetype=${filetype}`;
};
export const putMarketMembershipFile = (id) => {
  return `${getServerBaseUrl()}/marketmembershipfile?app=MEMV2&id=${id}`;
};
export const deleteMarketMembershipFile = (id) => {
  return `${getServerBaseUrl()}/marketmembershipfile/${id}`;
};
export const getMarketMembershipOrders = (idGroup, idmarket) => {
  return `${getServerBaseUrl()}/marketmembershiporders?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}`;
};
export const postMarketMembershipOrder = (marketmembershipid) => {
  return `${getServerBaseUrl()}/marketmembershiporder?app=MEMV2&marketmembershipid=${marketmembershipid}`;
};
export const putMarketMembershipOrder = (id, market, event) => {
  if (!event)
    return `${getServerBaseUrl()}/marketmembershiporder?app=MEMV2&id=${id}&market=${market}`;
  else
    return `${getServerBaseUrl()}/marketmembershiporder?app=MEMV2&id=${id}&market=${market}&event=${event}`;
};
export const generateMarketMembershipOrderFile = (id) => {
  return `${getServerBaseUrl()}/marketmembershiporderfile?app=MEMV2&id=${id}`;
};
export const deleteMarketMembershipOrder = (id) => {
  return `${getServerBaseUrl()}/marketmembershiporder/${id}`;
};
export const getMarketMembershipClaims = (idGroup, idmarket) => {
  return `${getServerBaseUrl()}/marketmembershipclaims?app=MEMV2&idgroup=${idGroup}&idmarket=${idmarket}`;
};
export const postMarketMembershipClaim = (marketmembershipid) => {
  return `${getServerBaseUrl()}/marketmembershipclaim?app=MEMV2&marketmembershipid=${marketmembershipid}`;
};
export const putMarketMembershipClaim = (id) => {
  return `${getServerBaseUrl()}/marketmembershipclaim?app=MEMV2&id=${id}`;
};
export const deleteMarketMembershipClaim = (id) => {
  return `${getServerBaseUrl()}/marketmembershipclaim/${id}`;
};
export const getBills = (idGroup, displaymethod, energy) => {
  if (!energy)
    energy = 'all';
  return `${getServerBaseUrl()}/bills?app=MEMV2&idgroup=${idGroup}&displaymethod=${displaymethod}&energy=${energy}`;
};
export const getBillsQuery = (idGroup, displaymethod, energy, pageSize, page, sorted, search, filtered) => {
  if (!sorted)
    sorted = {};
  if (!filtered)
    filtered = [];
  if (!search)
    search = "";
  return `${getServerBaseUrl()
    }/bills?app=MEMV2&idgroup=${idGroup}&displaymethod=${displaymethod}&energy=${energy}&per=${pageSize}&page=${page}&search=${search}&filtered=${JSON.stringify(filtered)}&sorted=${JSON.stringify(sorted)}&idgroup=${idGroup}`;

};
export const postBills = (method) => {
  return `${getServerBaseUrl()}/bills?app=MEMV2&method=${method}`;
};

export const getBillDetail = (billid) => {
  return `${getServerBaseUrl()}/billdetail?app=MEMV2&billid=${billid}`;
};
export const createBillEtatPaiement = () => {
  return `${getServerBaseUrl()}/billetatpaiement?app=MEMV2`;
};
export const getBackOfficeRealestate = () => {
  return `${getServerBaseUrl()}/backoffice/realestate?app=MEMV2`;
};
export const putBackOfficeRealestate = (id) => {
  return `${getServerBaseUrl()}/backoffice/realestate?app=MEMV2&id=${id}`;
};
export const postBackOfficeRealestate = () => {
  return `${getServerBaseUrl()}/backoffice/realestate?app=MEMV2`;
};
export const deleteBackOfficeRealestate = (id) => {
  return `${getServerBaseUrl()}/backoffice/realestate/${id}`;
};
export const getArchitectureExport = (idGroup) => {
  return `${getServerBaseUrl()}/architectureexport?app=MEMV2&idgroup=${idGroup}`;
};
export const getMBMEquipments = (idGroup, controlable, omitpoints, workspaceid) => {
  if (!controlable)
    controlable = "false";
  if (!omitpoints)
    omitpoints = "false";
  if (workspaceid)
    return `${getServerBaseUrl()}/mbm/equipments?app=MEMV2&idgroup=${idGroup}&controlable=${controlable}&omitpoints=${omitpoints}&workspaceid=${workspaceid}`;
  else
    return `${getServerBaseUrl()}/mbm/equipments?app=MEMV2&idgroup=${idGroup}&controlable=${controlable}&omitpoints=${omitpoints}`;
};
export const putMBMEquipments = (method) => {
  return `${getServerBaseUrl()}/mbm/equipments?app=MEMV2&method=${method}`;
};
export const getMBMIotdevices = (idGroup, workspaceid) => {
  if (workspaceid)
    return `${getServerBaseUrl()}/mbm/iotdevices?app=MEMV2&idgroup=${idGroup}&workspaceid=${workspaceid}`;
  else
    return `${getServerBaseUrl()}/mbm/iotdevices?app=MEMV2&idgroup=${idGroup}`;
};
export const getMBMEquipmentAlarms = (idGroup, workspaceid) => {
  if (workspaceid)
    return `${getServerBaseUrl()}/mbm/equipmentalarms?app=MEMV2&idgroup=${idGroup}&workspaceid=${workspaceid}`;
  else
    return `${getServerBaseUrl()}/mbm/equipmentalarms?app=MEMV2&idgroup=${idGroup}`;
};
export const putMBMEquipmentAlarms = (id, type) => {
  return `${getServerBaseUrl()}/mbm/equipmentalarm?app=MEMV2&id=${id}&type=${type}`;
};
export const deleteMBMEquipmentAlarms = (id) => {
  return `${getServerBaseUrl()}/mbm/equipmentalarm/${id}`;
};
export const putMBMIotdevices = (method) => {
  return `${getServerBaseUrl()}/mbm/iotdevices?app=MEMV2&method=${method}`;
};
export const getMBMPointData = (pointid, datebegin, dateend, method) => {
  return `${getServerBaseUrl()}/mbm/pointdata?app=MEMV2&pointid=${pointid}&datebegin=${datebegin}&dateend=${dateend}&method=${method}`;
};
export const postMBMPointData = () => {
  return `${getServerBaseUrl()}/mbm/pointdata?app=MEMV2`;
};
export const getSchedules = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/schedules?app=MEMV2&idgroup=${idGroup}`;
};
export const putSchedule = (id) => {
  return `${getServerBaseUrl()}/mbm/schedules?app=MEMV2&id=${id}`;
};
export const postSchedule = () => {
  return `${getServerBaseUrl()}/mbm/schedules?app=MEMV2`;
};
export const deleteSchedule = (id) => {
  return `${getServerBaseUrl()}/mbm/schedules/${id}`;
};
export const putPoint = (type) => {
  return `${getServerBaseUrl()}/mbm/point?app=MEMV2&type=${type}`;
};
export const putPoints = (method) => {
  return `${getServerBaseUrl()}/mbm/points?app=MEMV2&method=${method}`;
};
export const getPoints = (idGroup, definition, equipment) => {
  if (idGroup) {
    if (definition)
      return `${getServerBaseUrl()}/mbm/points?app=MEMV2&idgroup=${idGroup}&definition=${definition}`;
    else
      return `${getServerBaseUrl()}/mbm/points?app=MEMV2&idgroup=${idGroup}`;
  }
  else if (equipment) {
    return `${getServerBaseUrl()}/mbm/points?app=MEMV2&equipment=${equipment}`;
  }
};
export const getAccountTemplates = (idGroup) => {
  return `${getServerBaseUrl()}/accounttemplates?app=MEMV2&idgroup=${idGroup}`;
};
export const getMBMAVOBBoxs = (idGroup, type) => {
  if (!type)
    type = "all";
  return `${getServerBaseUrl()}/mbm/avobboxs?app=MEMV2&idgroup=${idGroup}&type=${type}`;
};
export const postMBMAVOBBox = () => {
  return `${getServerBaseUrl()}/mbm/avobbox?app=MEMV2`;
};
export const putMBMAVOBBox = (id, action) => {
  return `${getServerBaseUrl()}/mbm/avobbox?app=MEMV2&id=${id}&action=${action}`;
};
export const deleteMBMAVOBBox = (id, type) => {
  return `${getServerBaseUrl()}/mbm/avobbox/${id}?type=${type}`;
};
export const getMBMIotConnectors = (idGroup, servertype) => {
  if (!servertype)
    servertype = "all";
  return `${getServerBaseUrl()}/mbm/iotconnectors?app=MEMV2&idgroup=${idGroup}&servertype=${servertype}`;
};
export const getMBMIotConnector = (id, method) => {
  return `${getServerBaseUrl()}/mbm/iotconnector?app=MEMV2&id=${id}&method=${method}`;
};
export const putMBMIotConnector = (id) => {
  return `${getServerBaseUrl()}/mbm/iotconnector?app=MEMV2&id=${id}`;
};
export const postMBMIotConnector = () => {
  return `${getServerBaseUrl()}/mbm/iotconnector?app=MEMV2`;
};
export const deleteMBMIotConnector = (id) => {
  return `${getServerBaseUrl()}/mbm/iotconnector/${id}`;
};
export const getMBMDashboard = (idGroup, workspaceid, type) => {
  if(!type)
    type = 'synthesis'
  if (workspaceid)
    return `${getServerBaseUrl()}/mbm/dashboard?app=MEMV2&idgroup=${idGroup}&workspaceid=${workspaceid}&type=${type}`;
  else
    return `${getServerBaseUrl()}/mbm/dashboard?app=MEMV2&idgroup=${idGroup}&type=${type}`;
};
export const getMBMCampaigns = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/campaigns?app=MEMV2&idgroup=${idGroup}`;
};
export const putMBMCampaign = (id) => {
  return `${getServerBaseUrl()}/mbm/campaign?app=MEMV2&id=${id}`;
};
export const postMBMCampaign = () => {
  return `${getServerBaseUrl()}/mbm/campaign?app=MEMV2`;
};
export const deleteMBMCampaign = (id) => {
  return `${getServerBaseUrl()}/mbm/campaign/${id}`;
};
export const getMBMCampaignEquipments = (campaignid) => {
  return `${getServerBaseUrl()}/mbm/campaignequipment?app=MEMV2&campaignid=${campaignid}`;
};
export const putMBMCampaignEquipment = (id) => {
  return `${getServerBaseUrl()}/mbm/campaignequipment?app=MEMV2&id=${id}`;
};
export const postMBMCampaignEquipment = () => {
  return `${getServerBaseUrl()}/mbm/campaignequipment?app=MEMV2`;
};
export const deleteMBMCampaignEquipment = (id) => {
  return `${getServerBaseUrl()}/mbm/campaignequipment/${id}`;
};
export const getMBMCampaignViews = (campaignid) => {
  return `${getServerBaseUrl()}/mbm/campaignview?app=MEMV2&campaignid=${campaignid}`;
};
export const putMBMCampaignView = (id) => {
  return `${getServerBaseUrl()}/mbm/campaignview?app=MEMV2&id=${id}`;
};
export const postMBMCampaignView = () => {
  return `${getServerBaseUrl()}/mbm/campaignview?app=MEMV2`;
};
export const deleteMBMCampaignView = (id) => {
  return `${getServerBaseUrl()}/mbm/campaignview/${id}`;
};
export const getMeterData = (groupid, meternumber, energy, datebegin, dateend, type, granularity, id) => {
  return `${getServerBaseUrl()}/meterdata?app=MEMV2&groupid=${groupid}&meternumber=${meternumber}&energy=${energy}&datebegin=${datebegin}&dateend=${dateend}&type=${type}&granularity=${granularity}&meterid=${id}`;
};
export const getDashboardViews = () => {
  return `${getServerBaseUrl()}/dashboardviews?app=MEMV2`;
};
export const getActionPlanDashboard = (actionplanid) => {
  return `${getServerBaseUrl()}/actionplandashboard?app=MEMV2&id=${actionplanid}`;
};
export const getUserLog = (userid) => {
  return `${getServerBaseUrl()}/userlog?app=MEMV2&userid=${userid}`;
};
export const postUserLog = (type, event) => {
  return `${getServerBaseUrl()}/userlog?app=MEMV2&type=${type}&event=${event}`;
};
export const getDictionnary = (groupid, method) => {
  return `${getServerBaseUrl()}/dictionnary?app=MEMV2&groupid=${groupid}&method=${method}`;
};
export const getActionRecommandation = (groupid) => {
  return `${getServerBaseUrl()}/actionrecommendation?app=MEMV2&groupid=${groupid}`;
};
export const getCeecampaigns = (idGroup) => {
  return `${getServerBaseUrl()}/ceecampaigns?app=MEMV2&idgroup=${idGroup}`;
};
export const getCeecampaign = (id) => {
  return `${getServerBaseUrl()}/ceecampaign?app=MEMV2&id=${id}`;
};
export const putCeecampaign = (id) => {
  return `${getServerBaseUrl()}/ceecampaign?app=MEMV2&id=${id}`;
};
export const postCeecampaign = () => {
  return `${getServerBaseUrl()}/ceecampaign?app=MEMV2`;
};
export const deleteCeecampaign = (id) => {
  return `${getServerBaseUrl()}/ceecampaign/${id}`;
};
export const getCeecampaignMemberships = (idGroup, idceecampaign) => {
  return `${getServerBaseUrl()}/ceecampaignmemberships?app=MEMV2&idgroup=${idGroup}&idceecampaign=${idceecampaign}`;
};
export const getCeecampaignMembership = (id) => {
  return `${getServerBaseUrl()}/ceecampaignmembership?app=MEMV2&id=${id}`;
};
export const putCeecampaignMembership = (id) => {
  return `${getServerBaseUrl()}/ceecampaignmembership?app=MEMV2&id=${id}`;
};
export const postCeecampaignMembership = (idceecampaign) => {
  return `${getServerBaseUrl()}/ceecampaignmembership?app=MEMV2&idceecampaign=${idceecampaign}`;
};
export const deleteCeecampaignMembership = (id) => {
  return `${getServerBaseUrl()}/ceecampaignmembership/${id}`;
};
export const getCeecampaignFiles = (idGroup, idceecampaign, filetype) => {
  return `${getServerBaseUrl()}/ceecampaignfiles?app=MEMV2&idgroup=${idGroup}&idceecampaign=${idceecampaign}&filetype=${filetype}`;
};
export const postCeecampaignFile = (idceecampaign, filetype) => {
  return `${getServerBaseUrl()}/ceecampaignfile?app=MEMV2&idceecampaign=${idceecampaign}&filetype=${filetype}`;
};
export const putCeecampaignFile = (id) => {
  return `${getServerBaseUrl()}/ceecampaignfile?app=MEMV2&id=${id}`;
};
export const deleteCeecampaignFile = (id) => {
  return `${getServerBaseUrl()}/ceecampaignfile/${id}`;
};
export const getCEECampaignMembershipCases = (idGroup, idceecampaign) => {
  return `${getServerBaseUrl()}/ceecampaignmembershipcases?app=MEMV2&idgroup=${idGroup}&idceecampaign=${idceecampaign}`;
};
export const postCEECampaignMembershipCase = (ceecampaignmembershipid) => {
  return `${getServerBaseUrl()}/ceecampaignmembershipcase?app=MEMV2&ceecampaignmembershipid=${ceecampaignmembershipid}`;
};
export const putCEECampaignMembershipCase = (id) => {
  return `${getServerBaseUrl()}/ceecampaignmembershipcase?app=MEMV2&id=${id}`;
};
export const deleteCEECampaignMembershipCase = (id) => {
  return `${getServerBaseUrl()}/ceecampaignmembershipcase/${id}`;
};
export const postNotification = () => {
  return `${getServerBaseUrl()}/notification?app=MEMV2`;
};
export const postHistoricalMeterRequest = (meterid, type, datebegin, dateend) => {
  return `${getServerBaseUrl()}/historicalmeterrequest?app=MEMV2&meterid=${meterid}&type=${type}&datebegin=${datebegin}&dateend=${dateend}`;
}
export const getChartV2 = (
  idGroup,
  chartId,
  chartDateBegin,
  chartDateEnd,
  multigroupmode,
  chartsource,
  viewid,
  requestid,
) => {
  if (!requestid)
    requestid = uuid();
  if (!chartsource || chartsource === 'existing')
    return `${getServerBaseUrl()}/chartv2?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&requestid=${requestid}`;
  else if (chartsource === 'created')
    return `${getServerBaseUrl()}/chartv2?dataMethod=displayedchart&idgroup=[${idGroup}]&chartid=${chartId}&chartdateend=${chartDateEnd}&chartdatebegin=${chartDateBegin}&multigroupmode=${multigroupmode}&chartsource=${chartsource}&viewid=${viewid}&requestid=${requestid}`;
};
export const getCpes = (idGroup) => {
  return `${getServerBaseUrl()}/cpes?app=MEMV2&idgroup=${idGroup}`;
};
export const getCpe = (id) => {
  return `${getServerBaseUrl()}/cpe?app=MEMV2&id=${id}`;
};
export const putCpe = (id) => {
  return `${getServerBaseUrl()}/cpe?app=MEMV2&id=${id}`;
};
export const postCpe = (idGroup) => {
  return `${getServerBaseUrl()}/cpe?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteCpe = (id) => {
  return `${getServerBaseUrl()}/cpe/${id}`;
};
export const postTertiaryBill = (func) => {
  return `${getServerBaseUrl()}/tertiarybill?app=MEMV2&function=${func}`;
};
export const getBudgets = (idGroup) => {
  return `${getServerBaseUrl()}/budgets?app=MEMV2&idgroup=${idGroup}`;
};
export const getBudget = (id) => {
  return `${getServerBaseUrl()}/budget?app=MEMV2&id=${id}`;
};
export const putBudget = (id) => {
  return `${getServerBaseUrl()}/budget?app=MEMV2&id=${id}`;
};
export const postBudget = (idGroup) => {
  return `${getServerBaseUrl()}/budget?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteBudget = (id) => {
  return `${getServerBaseUrl()}/budget/${id}`;
};
export const getWeather = (idGroup) => {
  return `${getServerBaseUrl()}/weather?app=MEMV2&idgroup=${idGroup}`;
};
export const getEvents = (idGroup) => {
  return `${getServerBaseUrl()}/events?app=MEMV2&idgroup=${idGroup}`;
};
export const getEvent = (id) => {
  return `${getServerBaseUrl()}/event?app=MEMV2&id=${id}`;
};
export const putEvent = (id, idGroup) => {
  return `${getServerBaseUrl()}/event?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postEvent = (idGroup) => {
  return `${getServerBaseUrl()}/event?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteEvent = (id) => {
  return `${getServerBaseUrl()}/event/${id}`;
};
export const postCampaignCopy = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/campaigncopy?app=MEMV2&idgroup=${idGroup}`;
};
export const getChartsV2 = (idGroup) => {
  return `${getServerBaseUrl()}/chartsv2?app=MEMV2&idgroup=${idGroup}`;
};
export const putChartV2 = (id) => {
  return `${getServerBaseUrl()}/chartv2?app=MEMV2&id=${id}`;
};
export const postChartV2 = () => {
  return `${getServerBaseUrl()}/chartv2?app=MEMV2`;
};
export const deleteChartV2 = (id) => {
  return `${getServerBaseUrl()}/chartv2/${id}`;
};
export const getChartpoints = (idGroup, workspaceid) => {
  if (workspaceid)
    return `${getServerBaseUrl()}/chartpoints?app=MEMV2&idgroup=${idGroup}&workspaceid=${workspaceid}`;
  else
    return `${getServerBaseUrl()}/chartpoints?app=MEMV2&idgroup=${idGroup}`;
};
export const getVehicles = (idGroup) => {
  return `${getServerBaseUrl()}/vehicles?app=MEMV2&idgroup=${idGroup}`;
};
export const getVehicle = (id) => {
  return `${getServerBaseUrl()}/vehicle?app=MEMV2&id=${id}`;
};
export const putVehicle = (id, idGroup) => {
  return `${getServerBaseUrl()}/vehicle?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postVehicle = (idGroup) => {
  return `${getServerBaseUrl()}/vehicle?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteVehicle = (id) => {
  return `${getServerBaseUrl()}/vehicle/${id}`;
};
export const getGEBWorkspaces = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/gebworkspaces?app=MEMV2&idgroup=${idGroup}`;
};
export const getGEBWorkspace = (id) => {
  return `${getServerBaseUrl()}/mbm/gebworkspace?app=MEMV2&id=${id}`;
};
export const putGEBWorkspace = (id, idGroup) => {
  return `${getServerBaseUrl()}/mbm/gebworkspace?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postGEBWorkspace = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/gebworkspace?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteGEBWorkspace = (id) => {
  return `${getServerBaseUrl()}/mbm/gebworkspace/${id}`;
};
export const getGEBMeteringPlans = (workspace) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplans?app=MEMV2&workspace=${workspace}`;
};
export const getGEBMeteringPlan = (id) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplan?app=MEMV2&id=${id}`;
};
export const putGEBMeteringPlan = (id, idGroup) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplan?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postGEBMeteringPlan = (idGroup, workspace) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplan?app=MEMV2&idgroup=${idGroup}&workspace=${workspace}`;
};
export const deleteGEBMeteringPlan = (id) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplan/${id}`;
};
export const getGEB2DPlans = (workspace) => {
  return `${getServerBaseUrl()}/mbm/geb2Dplans?app=MEMV2&workspace=${workspace}`;
};
export const getGEB2DPlan = (id) => {
  return `${getServerBaseUrl()}/mbm/geb2Dplan?app=MEMV2&id=${id}`;
};
export const putGEB2DPlan = (id, idGroup) => {
  return `${getServerBaseUrl()}/mbm/geb2Dplan?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postGEB2DPlan = (idGroup, workspace) => {
  return `${getServerBaseUrl()}/mbm/geb2Dplan?app=MEMV2&idgroup=${idGroup}&workspace=${workspace}`;
};
export const deleteGEB2DPlan = (id) => {
  return `${getServerBaseUrl()}/mbm/geb2Dplan/${id}`;
};
export const putGEBMeteringPlanItem = (id, father) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplanitem?app=MEMV2&id=${id}&father=${father}`;
};
export const postGEBMeteringPlanItem = (father, meteringplan) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplanitem?app=MEMV2&father=${father}&meteringplan=${meteringplan}`;
};
export const deleteGEBMeteringPlanItem = (id) => {
  return `${getServerBaseUrl()}/mbm/gebmeteringplanitem/${id}`;
};
export const putGEB2dPlanItem = (id) => {
  return `${getServerBaseUrl()}/mbm/geb2dplanitem?app=MEMV2&id=${id}`;
};
export const postGEB2dPlanItem = (plan) => {
  return `${getServerBaseUrl()}/mbm/geb2dplanitem?app=MEMV2&&plan=${plan}`;
};
export const deleteGEB2dPlanItem = (id) => {
  return `${getServerBaseUrl()}/mbm/geb2dplanitem/${id}`;
};
export const getMBMIotDevice = (id) => {
  return `${getServerBaseUrl()}/mbm/iotdevice?app=MEMV2&id=${id}`;
};
export const putMBMIotDevice = (id, updategroupchoice) => {
  return `${getServerBaseUrl()}/mbm/iotdevice?app=MEMV2&id=${id}&updategroupchoice=${updategroupchoice}`;
};
export const deleteMBMIotDevice = (id) => {
  return `${getServerBaseUrl()}/mbm/iotdevice/${id}`;
};
export const getMBMEquipment = (id) => {
  return `${getServerBaseUrl()}/mbm/equipment?app=MEMV2&id=${id}`;
};
export const putMBMEquipment = (id, updategroupchoice) => {
  return `${getServerBaseUrl()}/mbm/equipment?app=MEMV2&id=${id}&updategroupchoice=${updategroupchoice}`;
};
export const deleteMBMEquipment = (id) => {
  return `${getServerBaseUrl()}/mbm/equipment/${id}`;
};
export const getGEBScripts = (workspace) => {
  return `${getServerBaseUrl()}/mbm/gebscripts?app=MEMV2&workspace=${workspace}`;
};
export const getGEBScript = (id) => {
  return `${getServerBaseUrl()}/mbm/gebscript?app=MEMV2&id=${id}`;
};
export const putGEBScript = (id, method) => {
  if (!method)
    method = 'save';
  return `${getServerBaseUrl()}/mbm/gebscript?app=MEMV2&method=${method}&id=${id}`;
};
export const postGEBScript = (workspace) => {
  return `${getServerBaseUrl()}/mbm/gebscript?app=MEMV2&workspace=${workspace}`;
};
export const deleteGEBScript = (id) => {
  return `${getServerBaseUrl()}/mbm/gebscript/${id}`;
};
export const getBillDashboard = (idGroup, energy, sendertype, year, type) => {
  if (!type)
    type = 'monthly';
  return `${getServerBaseUrl()}/billdashboard?app=MEMV2&idgroup=${idGroup}&sendertype=${sendertype}&year=${year}&energy=${energy}&type=${type}`;

};
export const getFlexBacsList = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/flexbacslist?app=MEMV2&idgroup=${idGroup}`;
};
export const getFlexBacsStatus = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/flexbacsstatus?app=MEMV2&idgroup=${idGroup}`;
};
export const getFlexBacsDataStream = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/flexstreambacsdata?app=MEMV2&idgroup=${idGroup}`;
};
export const getFlexDashboard = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/flexdashboard?app=MEMV2&idgroup=${idGroup}`;
};
export const getFlexLogs = (bacsid) => {
  return `${getServerBaseUrl()}/mbm/flexlogs?app=MEMV2&bacsid=${bacsid}`;
};
export const putApiMeterRequest = (id, method) => {
  return `${getServerBaseUrl()}/apimeterrequest?app=MEMV2&amrid=${id}&method=${method}`;
};
export const putApiMeterRequestBulk = (method) => {
  return `${getServerBaseUrl()}/apimeterrequest/bulk?app=MEMV2&method=${method}`;
};
export const getGEBAutomations = (workspace) => {
  return `${getServerBaseUrl()}/mbm/gebautomations?app=MEMV2&workspace=${workspace}`;
};
export const getGEBAutomation = (id) => {
  return `${getServerBaseUrl()}/mbm/gebautomation?app=MEMV2&id=${id}`;
};
export const putGEBAutomation = (id, type,) => {
  return `${getServerBaseUrl()}/mbm/gebautomation?app=MEMV2&id=${id}&type=${type}`;
};
export const postGEBAutomation = (workspace) => {
  return `${getServerBaseUrl()}/mbm/gebautomation?app=MEMV2&workspace=${workspace}`;
};
export const deleteGEBAutomation = (id) => {
  return `${getServerBaseUrl()}/mbm/gebautomation/${id}`;
};
export const getSessions = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/sessions?app=MEMV2&idgroup=${idGroup}`;
};
export const putSession = (id, type) => {
  return `${getServerBaseUrl()}/mbm/session?app=MEMV2&id=${id}&type=${type}`;
};
export const postSession = () => {
  return `${getServerBaseUrl()}/mbm/session?app=MEMV2`;
};
export const deleteSession = (id) => {
  return `${getServerBaseUrl()}/mbm/session/${id}`;
};
export const getSystemAlerts = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/systemalerts?app=MEMV2&idgroup=${idGroup}`;
};
export const putSystemAlert = (id, type) => {
  return `${getServerBaseUrl()}/mbm/systemalert?app=MEMV2&id=${id}&type=${type}`;
};
export const deleteSystemAlert = (id) => {
  return `${getServerBaseUrl()}/mbm/systemalert/${id}`;
};
export const createFlexRequest = (bacid, assetid) => {
  return `${getServerRootUrl()}/bacs/${bacid}/assets/${assetid}/flexibilities/request`;
};
export const confirmFlexRequest = (bacid, assetid, requestid) => {
  return `${getServerRootUrl()}/bacs/${bacid}/assets/${assetid}/flexibilities/request/${requestid}/confirm`;
};
export const getGEITWorkspaces = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/geitworkspaces?app=MEMV2&idgroup=${idGroup}`;
};
export const getGEITWorkspace = (id) => {
  return `${getServerBaseUrl()}/mitm/geitworkspace?app=MEMV2&id=${id}`;
};
export const putGEITWorkspace = (id, idGroup) => {
  return `${getServerBaseUrl()}/mitm/geitworkspace?app=MEMV2&id=${id}&idgroup=${idGroup}`;
};
export const postGEITWorkspace = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/geitworkspace?app=MEMV2&idgroup=${idGroup}`;
};
export const deleteGEITWorkspace = (id) => {
  return `${getServerBaseUrl()}/mitm/geitworkspace/${id}`;
};
export const getMITMSchedules = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/schedules?app=MEMV2&idgroup=${idGroup}`;
};
export const putMITMSchedule = (id) => {
  return `${getServerBaseUrl()}/mitm/schedules?app=MEMV2&id=${id}`;
};
export const postMITMSchedule = () => {
  return `${getServerBaseUrl()}/mitm/schedules?app=MEMV2`;
};
export const deleteMITMSchedule = (id) => {
  return `${getServerBaseUrl()}/mitm/schedules/${id}`;
};
export const getMITMComputers = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/computers?app=MEMV2&idgroup=${idGroup}`;
};
export const getMITMDashboard = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/dashboard?app=MEMV2&idgroup=${idGroup}`;
};
export const getMITMPolicies = (idGroup) => {
  return `${getServerBaseUrl()}/mitm/policies?app=MEMV2&idgroup=${idGroup}`;
};
export const getLinkedCalendars = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/linkedcalendars?app=MEMV2&idgroup=${idGroup}`;
};
export const putLinkedCalendar = (id) => {
  return `${getServerBaseUrl()}/mbm/linkedcalendars?app=MEMV2&id=${id}`;
};
export const postLinkedCalendar = () => {
  return `${getServerBaseUrl()}/mbm/linkedcalendars?app=MEMV2`;
};
export const deleteLinkedCalendar = (id) => {
  return `${getServerBaseUrl()}/mbm/linkedcalendars/${id}`;
};
export const getVirtualSensors = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/virtualsensor?app=MEMV2&idgroup=${idGroup}`;
};
export const putVirtualSensor = (id) => {
  return `${getServerBaseUrl()}/mbm/virtualsensor?app=MEMV2&id=${id}`;
};
export const postVirtualSensor = () => {
  return `${getServerBaseUrl()}/mbm/virtualsensor?app=MEMV2`;
};
export const deleteVirtualSensor = (id) => {
  return `${getServerBaseUrl()}/mbm/virtualsensor/${id}`;
};
export const getGEBAutomationQRLaunch = (id) => {
  return `${getServerBaseUrl()}/mbm/gebautomationqrlaunch`;
};
export const getLorawanthreads = (idGroup) => {
  return `${getServerBaseUrl()}/mbm/lorawanthreads?app=MEMV2&idgroup=${idGroup}`;
};
export const putLorawanthread = (id, type) => {
  return `${getServerBaseUrl()}/mbm/lorawanthread?app=MEMV2&id=${id}&type=${type}`;
};
export const postLorawanthread = () => {
  return `${getServerBaseUrl()}/mbm/lorawanthread?app=MEMV2`;
};
export const deleteLorawanthread = (id) => {
  return `${getServerBaseUrl()}/mbm/lorawanthread/${id}`;
};